module.exports = __webpack_public_path__ + "static/media/posicao_amamentar6.58cab07e.jpg";